export default __webpack_public_path__ + "static/media/icon_coaching_specialty.1ad09805.svg";